import React, { useEffect, useState } from 'react';
import {
	Grid,
	Box,
	Hidden,
	Button,
	useMediaQuery,
	useTheme,
} from '@material-ui/core';
import musafirbazarlogo from '../../assets/images/musafirbazarlogo.png';
import header from '../../assets/images/header-bg.jpg';
import TitleText from '../../components/reusableComponents/TitleText';
import { useDispatch } from 'react-redux';
import { fetchBannerDispatch } from '../../reducers/BannerReducer';
import { fetchCityDispatch } from '../../reducers/HomeReducer';
import '../../pages/Desktop/Agents.css';
import { useHistory } from 'react-router-dom';
import OurServiceSection from './OurServiceSection';
import {
	travellerSignupDispatch,
	agentSignupDispatch,
} from '../../reducers/UserReducer';
import SuccessModal from './SuccessModal';
import ErrorModal from './ErrorModal';
const dataService = [
	{
		id: 1,
		title: 'Affordable Hotels Booking',
		fontawesomeIcon: 'fas fa-hotel',
		desc: 'We offer the easiest hotel reservation services for you to take advantage of. Avail the best prices and check out accurate hotel listings in India and abroad',
	},
	{
		id: 2,
		title: 'Fastest Travel Booking',
		fontawesomeIcon: 'fas fa-plane',
		desc: 'Book Your Flight And Train Tickets Online Without Going Through Any Hassle. Check Availability Of Seats, Schedule And Compare Fares For Both Domestic As Well As Foreign Travel.',
	},
	{
		id: 3,
		title: 'Bus Booking',
		fontawesomeIcon: 'fas fa-bus',
		desc: 'A bus reservation system is a mobile or web software solution designed to provide customers with a personalized easy-to-utilize user experience for booking and purchasing tickets online.',
	},

	{
		id: 4,
		title: 'Car Booking',
		fontawesomeIcon: 'fas fa-car',
		desc: 'Our car rental system is a web-based booking system intended to meet the particular needs of car rental organizations, travel consolidators, and travel agents.',
	},
	{
		id: 5,
		title: 'new adventures',
		fontawesomeIcon: 'fas fa-hiking',
		desc: 'Tour Packages are one of the best ways to travel hassle-free. With seamless planning, arrangements, and transfers being taken care of, booking tour packages from india is the best way to explore the world’s varied landscapes.',
	},
	{
		id: 6,
		title: 'Holiday Package',
		fontawesomeIcon: 'fas fa-globe',
		desc: 'Tour Packages are one of the best ways to travel hassle-free. With seamless planning, arrangements, and transfers being taken care of, booking tour packages from india is the best way to explore the world’s varied landscapes.',
	},
];
const TravellerSignup = () => {
	const [user, setUser] = useState({
		userTitle: 'Mr',
		userFirstName: '',
		userLastName: '',
		userPhone: '',
		userEmail: '',
		password: '',
		confirmpassword: '',
	});
	const {
		userFirstName,
		userLastName,
		userPhone,
		userEmail,
		password,
		confirmpassword,
	} = user;

	const dispatch = useDispatch();
	const theme = useTheme();
	const history = useHistory();
	const onInputChange = (e) => {
		setUser({ ...user, [e.target.name]: e.target.value });
	};
	const onSubmit = async (e) => {
		e.preventDefault();
		var dat = user;
		var formData = JSON.stringify(dat);
		console.log(formData);
		// dispatch(agentSignupDispatch(formData, history));
		dispatch(travellerSignupDispatch(formData, history));
	};
	const matches2 = useMediaQuery(theme.breakpoints.down('xs'));
	// useEffect(() => {
	// 	dispatch(fetchBannerDispatch());
	// 	dispatch(fetchCityDispatch());
	// }, []);
	return (
		<>
			<nav className='navbar' style={{ background: 'white' }}>
				<div className='container flex'>
					<div
						className='site-brand'
						onClick={() => history.push('/')}
						style={{ cursor: 'pointer' }}>
						<img
							src={musafirbazarlogo}
							style={{ width: 300, display: 'block' }}></img>
					</div>

					<Hidden only={['xs']}>
						<Box display='flex' alignItems='center'>
							<TitleText textStyle={{ fontSize: 26, color: 'red' }}>
								Traveller Helpline{' '}
							</TitleText>
							<TitleText
								textStyle={{
									fontSize: 20,
									color: 'red',
									fontWeight: 'revert',
									marginLeft: 10,
								}}>
								+91 9798779484
							</TitleText>
						</Box>
					</Hidden>
				</div>
			</nav>
			<section
				style={{
					backgroundImage: `url(${header})`,
					paddingTop: '7rem',
					position: 'relative',
					backgroundSize: 'cover',
					backgroundRepeat: 'no-repeat',
					height: 1150,
					// backgroundPosition: '1px -461px',
				}}>
				<Grid container>
					<div className='form-box' style={{ width: 1110 }}>
						<h2 style={{ fontSize: 26 }}> Register Here</h2>
						<form onSubmit={(e) => onSubmit(e)}>
							<Grid container spacing={2}>
								<Grid item xs={12} md={6}>
									<div className='input-group'>
										<label>First Name</label>
										<input
											type='text'
											name='userFirstName'
											value={userFirstName}
											onChange={(e) => onInputChange(e)}
										/>
									</div>
								</Grid>
								<Grid item xs={12} md={6}>
									<div className='input-group'>
										<label>Last Name</label>
										<input
											type='text'
											name='userLastName'
											value={userLastName}
											onChange={(e) => onInputChange(e)}
										/>
									</div>
								</Grid>
							</Grid>
							<Grid container spacing={2}>
								<Grid item xs={12} md={6}>
									<div className='input-group'>
										<label>Phone</label>
										<input
											type='number'
											name='userPhone'
											value={userPhone}
											onChange={(e) => onInputChange(e)}
										/>
									</div>
								</Grid>
								<Grid item xs={12} md={6}>
									<div className='input-group'>
										<label>Email</label>
										<input
											type='email'
											name='userEmail'
											value={userEmail}
											onChange={(e) => onInputChange(e)}
										/>
									</div>
								</Grid>
							</Grid>
							<Grid container spacing={2}>
								<Grid item xs={12} md={6}>
									<div className='input-group'>
										<label>Password</label>
										<input
											type='password'
											name='password'
											value={password}
											onChange={(e) => onInputChange(e)}
										/>
									</div>
								</Grid>
								<Grid item xs={12} md={6}>
									<div className='input-group'>
										<label>Confirm Password</label>
										<input
											type='password'
											name='confirmpassword'
											value={confirmpassword}
											onChange={(e) => onInputChange(e)}
										/>
									</div>
								</Grid>
							</Grid>
							{/* <Grid container spacing={2}>
								<Grid item xs={12} md={6}>
									<div className='input-group'>
										<label>Address</label>
										<input type='text' />
									</div>
								</Grid>
								<Grid item xs={12} md={6}>
									<div className='input-group'>
										<label>Mobile</label>
										<input type='text' />
									</div>
								</Grid>
							</Grid>
							<Grid container spacing={2}>
								<Grid item xs={12} md={6}>
									<div className='input-group'>
										<label>State</label>
										<input type='text' />
									</div>
								</Grid>
								<Grid item xs={12} md={6}>
									<div className='input-group'>
										<label>City</label>
										<input type='text' />
									</div>
								</Grid>
							</Grid>
							<Grid container spacing={2}>
								<Grid item xs={12} md={6}>
									<div className='input-group'>
										<label>Pin Code</label>
										<input type='text' />
									</div>
								</Grid>
								<Grid item xs={12} md={6}>
									<div className='input-group'>
										<label>Reference</label>
										<input type='text' />
									</div>
								</Grid>
							</Grid> */}
							<Grid container spacing={2} style={{ justifyContent: 'center' }}>
								<button
									className='form-control'
									style={{
										background: 'rgb(239, 51, 57)',
										color: 'white',
										fontSize: '24px',
										borderRadius: '14px',
										marginTop: 20,
									}}>
									Register
								</button>
							</Grid>
						</form>
						<p
							style={{ fontSize: 16, cursor: 'pointer' }}
							onClick={() => history.push('/agent')}>
							Sign in instead
						</p>
					</div>
				</Grid>
			</section>
			<section
				className='services'
				id='services'
				style={{ paddingTop: matches2 ? '50rem' : '' }}>
				<h1 className='heading'>
					{' '}
					Our <span>services</span>{' '}
				</h1>

				<div className='box-container'>
					{dataService.map((item, index) => {
						return <OurServiceSection item={item} index={index} />;
					})}
				</div>
			</section>
			<footer className='py-4'>
				<div className='container footer-row'>
					<div className='footer-item'>
						<h2>Musafir Bazar</h2>
						<ul>
							<li>
								<a href='#' style={{ fontSize: 16 }}>
									Company Info
								</a>
							</li>
							<li style={{ marginTop: 5 }}>
								<a href='#' style={{ fontSize: 16 }}>
									Company Policy
								</a>
							</li>
							<li style={{ marginTop: 5 }}>
								<a href='#' style={{ fontSize: 16 }}>
									Privacy Policy
								</a>
							</li>
							<li style={{ marginTop: 5 }}>
								<a href='#' style={{ fontSize: 16 }}>
									Terms & Conditions
								</a>
							</li>
							<li style={{ marginTop: 5 }}>
								<a href='#' style={{ fontSize: 16 }}>
									About Us
								</a>
							</li>
							<li style={{ marginTop: 5 }}>
								<a href='#' style={{ fontSize: 16 }}>
									Cancellation/ Refund Policy
								</a>
							</li>
						</ul>
					</div>

					<div className='footer-item'>
						<h2>Follow us on: </h2>
						<ul className='social-links'>
							<li>
								<a
									style={{ fontSize: 22 }}
									href='https://www.facebook.com/musafirbazaar'
									target='_blank'>
									<i className='fab fa-facebook-f'></i>
								</a>
							</li>
							<li>
								<a
									style={{ fontSize: 22 }}
									href='https://www.instagram.com/musafirbazar/'
									target='_blank'>
									<i className='fab fa-instagram'></i>
								</a>
							</li>
							<li>
								<a
									style={{ fontSize: 22 }}
									href='https://twitter.com/musafirbazar'
									target='_blank'>
									<i className='fab fa-twitter'></i>
								</a>
							</li>
							<li>
								<a style={{ fontSize: 22 }} href='#'>
									<i className='fab fa-pinterest'></i>
								</a>
							</li>
							<li>
								<a style={{ fontSize: 22 }} href='#'>
									<i className='fab fa-google-plus'></i>
								</a>
							</li>
						</ul>
					</div>

					<div className='footer-item'>
						<h2>Products</h2>
						<ul>
							<li>
								<a href='#' style={{ fontSize: 16 }}>
									Flight Booking
								</a>
							</li>
							<li>
								<a href='#' style={{ fontSize: 16 }}>
									Bus Booking
								</a>
							</li>
							<li>
								<a href='#' style={{ fontSize: 16 }}>
									Car Booking
								</a>
							</li>
							<li>
								<a href='#' style={{ fontSize: 16 }}>
									Holiday Package
								</a>
							</li>
							<li>
								<a href='#' style={{ fontSize: 16 }}>
									Hotel Booking
								</a>
							</li>
						</ul>
					</div>
					<div className='footer-item'>
						<h2>Contact Info</h2>
						<ul>
							<li>
								<a href='#' style={{ fontSize: 16 }}>
									+91 8877773388
								</a>
							</li>
							<li>
								<a href='#' style={{ fontSize: 16 }}>
									sales@musafirbazaar.com
								</a>
							</li>
							<li>
								<a href='#' style={{ fontSize: 16 }}>
									1st Floor,New Tech Grand, Bank More, Dhanbad-826001
								</a>
							</li>
						</ul>
					</div>
					{/* <div className='subscribe-form footer-item'>
						<h2>Subscribe for Newsletter!</h2>
						<form className='flex'>
							<input
								type='email'
								placeholder='Enter Email'
								className='form-control'
							/>
							<input type='submit' className='btn' value='Subscribe' />
						</form>
					</div> */}
				</div>
			</footer>
			<SuccessModal />
			<ErrorModal />
		</>
	);
};

export default TravellerSignup;
